import axios from 'axios';
import authHeader from './auth-header';

//const API_URL = 'http://localhost:8080/matrix-mlm/api/mlm/mebou/';
const API_URL = 'https://www.edibleherbsstores.com/api/mlm/mebou/';

class MemberBonusService {
  getAll() {
    return axios.get(API_URL + `memberbonus/all`, { headers: authHeader() });
  }

  get(id) {
    return axios.get(API_URL + `memberbonus/${id}`, { headers: authHeader() });
  }

  create(memberBonus) {
    return axios.post(API_URL + `memberbonus/cre`, {
      bonusId: memberBonus.bonusId,
      memberId: memberBonus.memberId,
      downline: memberBonus.downline,
      salesId: memberBonus.salesId,
      settingId: memberBonus.settingId,
      bonusAmount: memberBonus.bonusAmount,
      bonusPurchaseDate: memberBonus.bonusPurchaseDate,
      bonusDate: memberBonus.bonusDate,
      paymentDate: memberBonus.paymentDate,
      paymentStatus: memberBonus.paymentStatus,
      readyToPay: memberBonus.readyToPay
    }, { headers: authHeader() });
  }

  update(id, memberBonus) {
    return axios.put(API_URL + `memberbonus/${id}/upd`, {
      id: memberBonus.id,  
      bonusId: memberBonus.bonusId,
      memberId: memberBonus.memberId,
      downline: memberBonus.downline,
      salesId: memberBonus.salesId,
      settingId: memberBonus.settingId,
      bonusAmount: memberBonus.bonusAmount,
      bonusPurchaseDate: memberBonus.bonusPurchaseDate,
      bonusDate: memberBonus.bonusDate,
      paymentDate: memberBonus.paymentDate,
      paymentStatus: memberBonus.paymentStatus,
      readyToPay: memberBonus.readyToPay
    }, { headers: authHeader() });
  }

  delete(id) {
    return axios.delete(API_URL + `del/${id}`, { headers: authHeader() });
  }

  deleteAll() {
    return axios.delete(API_URL + `delall`, { headers: authHeader() });
  }

  getMemberBonusesByDate(startDate, endDate) {
    return axios.get(API_URL + `memberbonus/${startDate}/${endDate}/date`, { headers: authHeader() });
  }

  getMemberBonusesByMemberId(memberId) {
    return axios.get(API_URL + `memberbonus/${memberId}/member`, { headers: authHeader() });
  }

  getPayoutsByMember(memberId) {
    return axios.get(API_URL + `memberbonus/${memberId}/memberpayouts`, { headers: authHeader() });
  }

  getTotalBonus(memberId) {
    return axios.get(API_URL + `memberbonus/${memberId}/totalbonus`, { headers: authHeader() });
  }

  getTotalPaidBonus(memberId) {
    return axios.get(API_URL + `memberbonus/${memberId}/totalpaidbonus`, { headers: authHeader() });
  }

  getTotalUnPaidBonus(memberId) {
    return axios.get(API_URL + `memberbonus/${memberId}/totalunpaidbonus`, { headers: authHeader() });
  }

}

export default new MemberBonusService();